import React, { useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid2';
import 'leaflet/dist/leaflet.css';
import {
    Stack, Box, Typography,
} from '@mui/material';

import MapTyphoon from '../components/typhoon_map';
import MapTyphoonSub from '../components/typhoon_sub_map';
import TyphoonLine from '../components/typhoon_line';
import CommonCard from '../item/common_card';
import Proggress from '../item/progress'
import HeaderSub from '../item/header_sub'
import ColorCard from '../item/color_card'

// import { useDataPolling, useDataFromS3 } from '../func/get_data_swr';
import { useDataFromS3 } from '../hooks/useDataFromS3';
import {
    RISK_LEVEL_POINT,
    BSN_RISK_LEVEL_POINT,
    RAIN_H1_LEVEL_POINT,
    RAIN_H24_LEVEL_POINT,
    TYPHOON_LEVEL_POINT,
    WIND_LEVEL_POINT,
    RISK_COLOR
} from '../const/color'

import '../style/legend_risk.css';
import { DEFAULT_POSITION } from '../config/config'

import {
    TypographyLeftMenu,
    TypographyTitle,
    TypographyBold14px,
} from '../style/typography'
import {
    BoxFlexEndTop,
    BoxCenter,
} from '../style/box'

import {
    setRainColor,
    setRainFontColor,
    setRiskColor,
    setRiskLabel,
    setRiskFontColor,
    setTyphoonColor,
    setWindColor,
} from '../func/color';

import {
    getStrDateTimePath,
} from '../func/risk_analysis_utils'

import choropleth_msh from '../data/msh.json';

const Typhoon = (props) => {

    const [dateArray, setDateArray] = useState(null);
    const [typhoonLayer, setTyphoonLayer] = useState([]);
    const [mainMapData, setMainMapData] = useState(null);
    const [subMapData, setSubMapData] = useState(null);
    // const [chartH1Data, setChartH1Data] = useState(null);
    const [chartPctData, setChartPctData] = useState(null);

    const [h1ValAry, setH1ValAry] = useState(null);
    const [h24ValAry, setH24ValAry] = useState(null);
    const [pctValAry, setPctValAry] = useState(null);
    const [windValAry, setWindValAry] = useState(null);
    const [rskValAry, setRskValAry] = useState(null);
    const [ofValAry, setOfValAry] = useState(null);

    const [shouldFetchMain, setShouldFetchMain] = useState(false);
    // 選択している緯度経度
    const currentLngLat = DEFAULT_POSITION

    // 選択している時間のインデックス
    const [chooseNum, setChooseNum] = useState(2)

    const prevDataARef = useRef(null);

    // 台風の全時間断面を取得する
    const { data, isLoading, error } = useDataFromS3(`api/get_typhoon_datetime_latest`);

    // 全データ再取得の要否を定期監視する
    // サーバーの最終更新日時が変更されているか判定
    useEffect(() => {
        if (data && JSON.stringify(data) !== JSON.stringify(prevDataARef.current)) {
            prevDataARef.current = data;
            setShouldFetchMain(true); // dataが変わったらメインデータを取得
        } else {
            setShouldFetchMain(false); // dataが変わってないならメインデータを取得しない
        }
    }, [data]);

    let typhoon_pct_index_url = null
    let typhoon_pct_url = null
    if (shouldFetchMain) {
        typhoon_pct_index_url = `api/get_typhoon_pct_index`
        typhoon_pct_url = `api/get_typhoon_pct`
    }

    // 台風マップ用のデータを取得
    const {
        data: typhoonPctMapData,
        loading: typhoonPctMapLoading,
        error: typhoonPctMapError,
    } = useDataFromS3(typhoon_pct_index_url);

    // 台風関連の気象データを取得
    const {
        data: typhoonPctData,
        loading: typhoonPctLoading,
        error: typhoonPctError,
    } = useDataFromS3(typhoon_pct_url);

    // データ整備用のパラメータを取得
    const getParamsMsh = (keyAry, keyName = '') => {

        // メッシュデータ取得
        const features_msh = choropleth_msh.features
        const mastreMshFeatures = features_msh.filter(f =>
            keyAry.includes(f.properties[keyName])
        );
        // メッシュデータの properties.id を配列で取得(これが対象のメッシュコード)
        const msh_code_ary = mastreMshFeatures.map(feature => feature.properties.id);

        return msh_code_ary
    }

    // 複合グラフのマーカー情報（土砂）
    const getPointsRisk = (date_ary, data_x) => {
        let points = []
        for (let i = 0; i < data_x.length; i++) {
            const color = setTyphoonColor(data_x[i]).color
            const point = {
                x: date_ary[i],
                y: data_x[i],
                marker: {
                    size: 4,
                    fillColor: color,
                    strokeColors: 'transparent',
                    strokeWidth: 0,
                    shape: "circle",
                },
            }
            points.push(point)
        }
        return points
    }
    const format = (val) => parseFloat(val).toFixed(0);

    // 選択されている typhoon_number を取得
    const getSelectedNumbers = () => {
        const typhoon_number_ary = typhoonLayer
            .filter(layer => layer.select)
            .map(layer => layer.typhoon_number);
        return typhoon_number_ary
    }

    // 選択されている typhoon_number に紐つくデータを取得
    const getTargetData = (data, selectedNumbers) => {
        return data
            .filter(obj => selectedNumbers.includes(obj.outer_key))
            .flatMap(obj =>
                obj.data.map(d => ({
                    ...d,
                    typhoon_number: obj.outer_key
                }))
            )
    }

    // 画面右下の地図の台風情報を取得
    const getSubMapData = () => {

        // 選択されている typhoon_number を取得
        const selectedNumbers = getSelectedNumbers();

        // 対象 outer_key の data をまとめて取り出す
        const targetData = getTargetData(typhoonPctMapData, selectedNumbers)

        // reduce ロジックを適用
        const result = Object.values(
            targetData.reduce((acc, { code, typhoon_pct, typhoon_number }) => {
                const maxVal = Math.max(...typhoon_pct);
                const idx = typhoon_pct.findIndex(v => v === maxVal);

                if (!acc[code] || maxVal > acc[code].val) {
                    acc[code] = {
                        code,
                        val: maxVal,
                        max_datetime: data[idx],
                        typhoon_name: typhoonLayer.find(layer => layer.typhoon_number === typhoon_number).typhoon_name
                    };
                }

                return acc;
            }, {})
        );

        return result;
    }

    // メイン地図の台風情報を取得
    const getMainMapData = () => {

        // 選択されている typhoon_number を取得
        const selectedNumbers = getSelectedNumbers();

        // 対象 outer_key の data をまとめて取り出す
        const targetData = getTargetData(typhoonPctMapData, selectedNumbers)

        // reduce ロジックを適用
        const result = Object.values(
            targetData.reduce((acc, { code, typhoon_pct, typhoon_number }) => {
                // 台風名を取得
                const typhoonName = typhoonLayer.find(layer => layer.typhoon_number === typhoon_number)?.typhoon_name;

                if (!acc[code]) {
                    // 初回はそのまま格納
                    acc[code] = {
                        code,
                        val: [...typhoon_pct],
                        typhoon_name: [...typhoon_pct.map(() => typhoonName)] // val と同じ長さの配列で名前を保持
                    };
                } else {
                    // 既存 val と新しい typhoon_pct を要素ごとに比較して更新
                    acc[code].val = acc[code].val.map((v, i) => {
                        if (typhoon_pct[i] > v) {
                            // 更新があれば val と typhoon_name 両方更新
                            acc[code].typhoon_name[i] = typhoonName;
                            return typhoon_pct[i];
                        }
                        return v;
                    });
                }
                return acc;
            }, {})
        );

        return result;
    }

    // チャート用の台風情報を取得
    const getBarLineData = (targetCodes) => {
        const selectedNumbers = getSelectedNumbers();
        // const targetData = getTargetData(typhoonPctData, selectedNumbers);
        // 対象 outer_key の data をまとめて取り出す（msh_code が配列に含まれるものだけ）
        const targetData = typhoonPctData
            .filter(obj => selectedNumbers.includes(obj.outer_key))
            .flatMap(obj =>
                obj.data
                    .filter(d => targetCodes.includes(d.code)) // ← 選択地域のメッシュコードでフィルタ
                    .map(d => ({
                        ...d,
                        typhoon_number: obj.outer_key
                    }))
            );

        if (targetData.length === 0) return null;
        // 最大値をとる対象キーを定義
        const keys = ["pct_val", "h1_val", "h24_val", "rsk_val", "of_val", "wind_val"];

        const result = targetData.reduce((acc, vals) => {
            keys.forEach(key => {
                // null は 0 に置き換え
                // const arr = Array.isArray(vals[key]) ? vals[key].map(v => v ?? 0) : [vals[key] ?? 0];
                const arr = Array.isArray(vals[key]) ? vals[key] : [vals[key]];

                if (!acc[key]) {
                    acc[key] = [...arr]; // 初回はコピー
                } else {
                    // 要素ごとに最大値を保持
                    // acc[key] = acc[key].map((v, i) => Math.max(v, arr[i] ?? 0));
                    acc[key] = acc[key].map((v, i) => {
                        const newVal = arr[i];

                        // 両方 null → null
                        if (v == null && newVal == null) return null;

                        // 片方だけ null → nullじゃない方を採用
                        if (v == null) return newVal;
                        if (newVal == null) return v;

                        // 両方数値 → 大きい方
                        return Math.max(v, newVal);
                    });
                }
            });

            // pct_val の場合は typhoon_name 配列も作る
            if (!acc.typhoon_name) {
                acc.typhoon_name = vals.pct_val.map(() => vals.typhoon_name);
            } else {
                acc.typhoon_name = acc.typhoon_name.map((name, i) =>
                    vals.pct_val[i] > (acc.pct_val[i] ?? 0) ? vals.typhoon_name : name
                );
            }

            return acc;
        }, {});
        return result;
    };

    useEffect(() => {
        // ローディング開始
        props.setReady(prev => {
            const updated = Object.fromEntries(
                Object.keys(prev).map(key => [key, false])
            );
            return updated;
        });
        const fetchData = async () => {

            // 選択した市町村に属する全メッシュコードを取得
            const msh_code_ary = getParamsMsh(props.selectCitys, 'city_code')

            // メイン地図の台風情報を取得
            setMainMapData(getMainMapData())
            // 画面右下の地図の台風情報を取得
            setSubMapData(getSubMapData())

            // チャート用の台風情報を取得
            const bar_line = getBarLineData(msh_code_ary)

            // // チャート棒グラフの１時間雨量
            // setChartH1Data(bar_line !== null ? bar_line.h1_val : null)
            // チャート折れ線グラフの暴風域に入る確率
            setChartPctData(bar_line !== null ? bar_line.pct_val : null)
            // １時間雨量の最大値
            setH1ValAry(bar_line !== null ? bar_line.h1_val : null)
            // 24時間雨量の最大値
            setH24ValAry(bar_line !== null ? bar_line.h24_val : null)
            // 風の最大値
            setWindValAry(bar_line !== null ? bar_line.wind_val : null)
            // 暴風域に入る確率の最大値
            setPctValAry(bar_line !== null ? bar_line.pct_val : null)
            // 被災リスク（土砂）の最大値
            setRskValAry(bar_line !== null ? bar_line.rsk_val : null)
            // 被災リスク（河川）の最大値
            setOfValAry(bar_line !== null ? bar_line.of_val : null)

        };
        if (data
            && typhoonPctMapData
            && typhoonPctData
            && typhoonLayer
        ) {
            fetchData();
        }
    }, [data,
        typhoonPctMapData,
        typhoonPctData,
        props.selectCitys, JSON.stringify(typhoonLayer),
    ]);

    useEffect(() => {
        if (typhoonPctMapData === undefined) return;

        // outer_key を台風番号として扱う
        const uniqueTyphoonNumbers = [...new Set(typhoonPctMapData.map(item => item.outer_key))];

        setTyphoonLayer(prev => {
            return uniqueTyphoonNumbers.map(num => {
                // 前回の同じ typhoon_number (= outer_key) を探す
                const existing = prev.find(layer => layer.typhoon_number === num);
                return existing
                    ? existing  // 前回の値があればそのまま（select状態維持）
                    : { // 新規は select: true
                        typhoon_number: num,
                        typhoon_name: `20${String(num).substring(0, 2)}年 台風${String(num).slice(-2)}号`,
                        select: true
                    };
            });
        });
    }, [typhoonPctMapData]);

    if (isLoading || data === undefined
        || (error && error.message.includes("Received HTML"))
        || typhoonPctMapLoading || typhoonPctMapData === undefined
        || typhoonPctLoading || typhoonPctData === undefined
        || (typhoonPctMapError && typhoonPctMapError.message.includes("Received HTML"))
        || (typhoonPctError && typhoonPctError.message.includes("Received HTML"))
    ) {
        // Loading表示
        return <Proggress />
    }

    if (error
        || typhoonPctMapError
        || typhoonPctError
    ) {
        return (
            <>
                <Typography
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white',
                    }}
                >
                    申し訳ございません、データ取得に失敗しました。
                </Typography>
                <Typography
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white',
                    }}
                >
                    恐れ入りますが、しばらく時間をおいてから再度お試しください。
                </Typography>
            </>
        )
    }

    const maxValueCards = (title, POINT, ary, unit, isRisk) => {
        let val = '-'
        let bgColor = RISK_COLOR.OTHER.color
        let fontColor = RISK_COLOR.OTHER.font_color
        if (ary !== null) {
            val = ary[chooseNum]
            if (isRisk) {
                if (val === null) {
                    // 有意な値がない場合は「-」だし、背景色もOTHERのまま
                    val = '-'
                } else {
                    // 有意な値の場合はラベルと背景色を設定
                    bgColor = setRiskColor(POINT, val)
                    fontColor = setRiskFontColor(POINT, val)
                    val = setRiskLabel(POINT, val)
                }
            } else {
                if (val === null) {
                    val = '-'
                }
                if (POINT === RAIN_H1_LEVEL_POINT || POINT === RAIN_H24_LEVEL_POINT) {
                    bgColor = setRainColor(POINT, val)
                    fontColor = setRainFontColor(POINT, val)
                }
                if (POINT === TYPHOON_LEVEL_POINT) {
                    bgColor = setTyphoonColor(val).color
                    fontColor = setTyphoonColor(val).font_color
                }
                if (POINT === WIND_LEVEL_POINT) {
                    bgColor = setWindColor(val).color
                    fontColor = setWindColor(val).font_color
                }
            }
        }

        return (
            <ColorCard
                child={
                    <>
                        <BoxCenter
                            height={"calc(((25dvh - (36px * 0.25) - (17px * 0.25) - (8px * 0.25) - (8px * 0.25) + 30px + 30px) /3 ) - 40px - 15px)"} >
                            <TypographyTitle
                                sx={{ color: fontColor, lineHeight: 1 }}
                            >{val}</TypographyTitle>
                            <TypographyBold14px
                                sx={{ color: fontColor, lineHeight: 1, paddingLeft: '5px' }}
                            >{unit}</TypographyBold14px>
                        </BoxCenter>
                        <BoxFlexEndTop>
                            <TypographyLeftMenu
                                sx={{ color: fontColor, lineHeight: 1 }}
                            >{data[chooseNum]}</TypographyLeftMenu>
                        </BoxFlexEndTop>
                    </>
                }
                title={title}
                bgColor={bgColor}
                fontColor={fontColor}
                xsHeight="30px"
                height="calc(((25dvh - (36px * 0.25) - (17px * 0.25) - (8px * 0.25) - (8px * 0.25) + 30px + 30px) /3 ) - 40px)"
            />)
    }

    return (
        <>
            <Box
                sx={{
                    // グローバルヘッダーの「36px」と大枠のGridのマージン上下「8px」ずつを差し引きく
                    height: { xs: '100%', sm: 'calc(100dvh - 36px - 8px - 8px - 8px)' }, // 親が高さを持つ
                    boxSizing: 'border-box',
                }}
            >
                <HeaderSub
                    pageTitle={""}
                    dateTime={data[2]}
                />
                <Grid container
                    spacing={0}
                    columns={12}
                    sx={{ height: '100%', width: '100%', padding: 0, m: 0 }} // Grid全体の高さ100%

                >
                    <Grid size={{ xs: 12, sm: 12, md: 8 }}>
                        <Stack >
                            <CommonCard
                                child={
                                    <MapTyphoon
                                        selectCitys={props.selectCitys}
                                        mapData={mainMapData}
                                        strDateTimePath={getStrDateTimePath(data[2])}
                                        currentLngLat={currentLngLat}
                                        typhoonLayer={typhoonLayer}
                                        setTyphoonLayer={setTyphoonLayer}
                                        setReady={props.setReady}
                                        chooseNum={chooseNum}
                                        prefCode={props.prefCode}
                                        setChooseNum={setChooseNum}
                                        dates={data}
                                    />
                                }
                                title={'台風の暴風域に入る確率'}
                                xsHeight="300px"
                                // グローバルヘッダーの「36px」と大枠のGridのマージン上下「8px」ずつを差し引きく
                                // 60dvhなので「* 0.6」している
                                // height='calc(70dvh - (36px * 0.7) - (17px * 0.7) - (8px * 0.7) - (8px * 0.7) - (80px * 0.7) - 31px)'
                                height='calc(75dvh - (36px * 0.75) - (17px * 0.75) - (8px * 0.75) - (8px * 0.75) - 31px)'
                            />

                            {/* Bar、Lineグラフ */}
                            <CommonCard
                                child={
                                    <>
                                        <TyphoonLine
                                            limitVal={130}
                                            dateArray={data}
                                            chartData={chartPctData}
                                            getPoints={getPointsRisk}
                                            seriesName={'暴風域に入る確率'}
                                            colors={['#5c9fed']}
                                            strokeColors={['#5c9fed']}
                                            shared={false}
                                            intersect={true}
                                            format={format}
                                            bottom={0}
                                            isReadyKey={['bar_line']}
                                            isReadyFlg={props.isReady.bar_line}
                                            setReady={props.setReady}
                                            chooseNum={chooseNum}
                                            dataLabelsOffsetY={-20}
                                        />
                                    </>
                                }
                                xsHeight="200px"
                                // グローバルヘッダーの「36px」と大枠のGridのマージン上下「8px」ずつを差し引きく
                                // 30dvhなので「* 0.3」している
                                // height='calc(30dvh - (36px * 0.3) - (17px * 0.3) - (8px * 0.3) - (8px * 0.3) - (80px * 0.3))'
                                height='calc(25dvh - (36px * 0.25) - (17px * 0.25) - (8px * 0.25) - (8px * 0.25) - (8px * 0.25))'
                            />

                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                        <Stack spacing={1}>
                            <CommonCard
                                child={
                                    <MapTyphoonSub
                                        selectCitys={props.selectCitys}
                                        mapData={subMapData}
                                        currentLngLat={currentLngLat}
                                        prefCode={props.prefCode}
                                    />
                                }
                                title={'120時間先までの台風が暴風域に入る確率'}
                                xsHeight="300px"
                                // height="calc(60dvh - (36px * 0.6) - (17px * 0.6) - (8px * 0.6) - 31px )"
                                height='calc(75dvh - (36px * 0.75) - (17px * 0.75) - (8px * 0.75) - (8px * 0.75) - 31px - 30px - 30px)'
                            />
                            {/* リスク・雨量最大値 */}
                            <Grid container columns={12} spacing={1}>
                                <Grid size={{ md: 6 }}>
                                    <Stack spacing={1}>
                                        {maxValueCards('1時間雨量', RAIN_H1_LEVEL_POINT, h1ValAry, 'mm/h', false)}
                                        {maxValueCards('風', WIND_LEVEL_POINT, windValAry, 'm/s', false)}
                                        {maxValueCards('土砂災害発生リスク', RISK_LEVEL_POINT, rskValAry, '', true)}
                                    </Stack>
                                </Grid>
                                <Grid size={{ md: 6 }}>
                                    <Stack spacing={1}>
                                        {maxValueCards('24時間雨量', RAIN_H24_LEVEL_POINT, h24ValAry, 'mm', false)}
                                        {maxValueCards('暴風域に入る確率', TYPHOON_LEVEL_POINT, pctValAry, '%', false)}
                                        {maxValueCards('流域平均流出量', BSN_RISK_LEVEL_POINT, ofValAry, '', true)}
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Stack>
                    </Grid>
                </Grid>
            </Box >
        </>
    )
}
export default Typhoon;